<template>
  <svg viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
    <path
      d="M15.275 16.4999H3.72503C3.44836 16.5 3.17443 16.4531 2.91896 16.3621C2.66349 16.2711 2.43152 16.1377 2.23638 15.9696C2.04124 15.8015 1.88677 15.602 1.78186 15.3825C1.67694 15.1631 1.62364 14.9281 1.62503 14.6909V6.24895C1.62503 5.96245 1.78253 5.69845 2.04503 5.5252L8.85253 1.6807C9.03399 1.56328 9.25516 1.49976 9.48253 1.49976C9.70989 1.49976 9.93106 1.56328 10.1125 1.6807L16.955 5.5252C17.2175 5.69845 17.375 5.96245 17.375 6.24895V14.6909C17.3764 14.9281 17.3231 15.1631 17.2182 15.3825C17.1133 15.602 16.9588 15.8015 16.7637 15.9696C16.5685 16.1377 16.3366 16.2711 16.0811 16.3621C15.8256 16.4531 15.5517 16.5 15.275 16.4999Z"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linejoin="round"
      :class="containerClass"
    />
    <path d="M7.575 9H11.425C11.81 9 12.125 9.27 12.125 9.6V16.5H6.875V9.6C6.875 9.27 7.19 9 7.575 9Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linejoin="round" :class="containerClass" />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type: [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
